import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFacetAccordionItem } from '#/modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from '#/modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from '#/modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { SEARCH_VOLOP_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchVolopRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { VOLOP_WELCOME_OPTIONS } from '#/utils/constants/general/welcomeOptions';

type Props = {
  variant: SearchRefinementVariant;
};

export function VolopWelcomeFacet({ variant }: Props) {
  const { i18n } = useI18n();
  const selectedFacetValues = useSearchFacetSelectedValues('welcome');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="welcome"
      icon="group"
      label={
        <>
          {SEARCH_VOLOP_REFINEMENT_LABELS(i18n).welcome}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="welcome"
        initialValue={selectedFacetValues}
        searchable
        options={VOLOP_WELCOME_OPTIONS(i18n)}
      />
    </FacetVariant>
  );
}
